<template>
  <b-row>
    <b-col md="12" class="mb-3">
      <h6 class="package-title" v-translate>Details</h6>
      <hr>
      <div class="package-name-background text-white p-2"><p>{{title}}</p></div>
      <h6 class="package-title my-3" v-translate>Price details</h6>
      <div class="table-responsive">
        <table class="table table-sm text-center">
          <thead class="t-head thead-light text-center">
            <tr>
              <th v-translate>Total client</th>
              <th v-translate>Taxes</th>
              <th> <span class="text-danger" v-translate> Commision </span> </th>
              <th v-translate>Total payment</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-primary">{{ meal.price + meal.tax + serviceTax  }}</td>
              <td>
                {{ meal.tax + serviceTax }}
              </td>
              <td class="text-danger">{{ meal.commission + serviceTax }}</td>
              <td class="text-success">{{ meal.price + meal.tax - meal.commission }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-card class="bg-light">
        <h6 class="package-title" v-translate>Discounts applied</h6>
        <div v-for="(discount, packDiscount) in discounts" :key="packDiscount">
          <h6 class="package-title">{{discount.label}}</h6>
          <p v-if="discount.bookingFrom || discount.bookingTo"><b><translate>Offer validity</translate>:&nbsp;</b>
            <span v-if="!discount.bookingFrom && !discount.bookingTo"><translate>any</translate></span>
            <span v-if="discount.bookingFrom && !discount.bookingTo"> <translate>from</translate> {{ discount.bookingFrom}}</span>
            <span v-if="!discount.bookingFrom && discount.bookingTo"> <translate>until</translate> {{ discount.bookingTo }}</span>
            <span v-if="discount.bookingFrom && discount.bookingTo"> <translate>between</translate> {{ discount.bookingFrom }} <translate>and</translate> {{ discount.bookingTo }}</span>
          </p>
          <hr>
          <p><b v-translate>Travel dates</b>:
            <span v-if="!discount.travelFrom && !discount.travelTo"><translate>any</translate></span>
            <span v-if="discount.travelFrom && !discount.travelTo"> <translate>from</translate> {{ discount.travelFrom}}</span>
            <span v-if="!discount.travelFrom && discount.travelTo"> <translate>until</translate> {{ discount.travelTo }}</span>
            <span v-if="discount.travelFrom && discount.travelTo"> <translate>between</translate> {{ discount.travelFrom }} <translate>and</translate>  {{ discount.travelTo }}</span>
          </p>
        </div>
        <p class="m-0" v-if="discounts.length == 0" v-translate>No discounts were applied</p>
      </b-card>
      <b-card class="bg-light mt-3" no-body v-if="paymentSchedule && paymentSchedule.length">
        <b-card-header>
          <b v-translate>Payments schedule</b>
        </b-card-header>
        <b-list-group flush>
          <b-list-group-item v-for="(dd, ddIndex) in paymentSchedule" :key="'dd' + ddIndex">
            {{ formatDate(dd.date) }} - <b>{{ ceil(dd.amount) || $gettext('balance') }}</b>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'

export default {
  name: 'PriceDetails',
  props: {
    title: String,
    meal: {
      type: Object,
      required: true
    },
    discounts: {
      type: Array,
      required: false,
      default: () => { return [] }
    },
    serviceTax: {
      type: Number,
      required: false,
      default: 0
    },
    paymentSchedule: {
      type: Array,
      required: false,
      default: () => { return [] }
    }
  },
  methods: {
    formatDate (d) {
      return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    ceil (no) {
      return Math.ceil(no)
    }
  }
}
</script>
